// extracted by mini-css-extract-plugin
export var avatarContainer = "_5p-1";
export var largeAvatarContainer = "_5p-2";
export var smallAvatarContainer = "_5p-0";